<template>
    <div class="tabs_content">
        <section>
            <div class="left">
                <h2 v-translate>Povolit/zakázat funkce</h2>
            </div>
            <div class="right checkbox_group">
                <input :disabled="!isEditable" @change="_onFeatureSettingsChanged" type="checkbox" id="feature_settings" name="feature_settings" :checked="entity.feature_settings">
                <label for="feature_settings" v-translate>Uplatňovat nastavení</label>

                <ul v-if="entity.feature_settings">
                    <li v-for="feature in availableValues.feature_settings" :key="feature">
                        <input :disabled="!isEditable" @change="_onCheckboxChange" type="checkbox" :id="'feature_' + feature" :name="feature" :checked="entity.feature_settings[feature]">
                        <label :for="'feature_' + feature">{{ getFeatureName(feature) }}</label>
                    </li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
import formFilterData from "@/components/mixins/form-filter-data"

export default {
    name: "Features",
    mixins: [formFilterData],
    props: {
        entity: Object,
        isEditable: Boolean,
        availableValues: Object
    },
    methods: {
        _onFeatureSettingsChanged(data) {
            if (data.target.checked) {
                this.entity.feature_settings = {};
            } else {
                this.entity.feature_settings = null;
            }
        },
        _onCheckboxChange(data) {
            const newFeatureSettings = {...this.entity.feature_settings};
            newFeatureSettings[data.target.name] = data.target.checked;

            this.entity.feature_settings = newFeatureSettings;
        },
        getFeatureName(featureName) {
            switch(featureName) {
                case 'allow_dashboard':
                    return this.$gettext('Dashboard');
                case 'allow_epg':
                    return this.$gettext('EPG');
                case 'allow_on_channel':
                    return this.$gettext('Pořady na kanálu');
                case 'allow_help':
                    return this.$gettext('Nápověda');
                case 'allow_search':
                    return this.$gettext('Hledání');
                case 'allow_pvrs':
                    return this.$gettext('Nahrávky');
                case 'allow_periodic_pvrs':
                    return this.$gettext('Pravidelné nahrávky');
                case 'allow_messages':
                    return this.$gettext('Oznámení');
                case 'allow_advertising_banners':
                    return this.$gettext('Marketingová oznámení');
                case 'allow_settings':
                    return this.$gettext('Nastavení');
                case 'allow_channel_groups':
                    return this.$gettext('Skupiny stanic');
                case 'allow_unlock':
                    return this.$gettext('Odemykání');
                case 'allow_vod':
                    return this.$gettext('Videotéka');
                case 'allow_selfservice':
                    return this.$gettext('Samoobsluha');
                case 'allow_unsubscribe_device':
                  return this.$gettext('Odhlášení zařízení');
                case 'allow_set_admin_pin':
                  return this.$gettext('Nastavení PIN administrátora');
                case 'allow_set_profile_pin':
                  return this.$gettext('Nastavení PIN profilu');
                case 'allow_set_maturity_rating':
                  return this.$gettext('Nastavení věkového omezení');
                default:
                    return featureName;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/forms/Features.vue